{#if show}
  <BaseDialog lg
    bind:show={show}
    {title}>
    <Panel>
    <!-- <div>Esto es una prueba</div> -->
    <QrLabelGenerator />
  </Panel>

  </BaseDialog>
{/if}

<script>
  import { Panel } from 'svelte-stylo'
  import BaseDialog from '@/components/dialogs/BaseDialog.svelte'
  import QrLabelGenerator from './qr-label-generator/QrLabelsGenerator.svelte'

  let
    show = false,
    recordDef = {},
    onDone = null
  
  const title = 'Generador de Etiquetas QR'
  
  window.RecordDefQrLabelDialog = function () {
    /** 
     * Set this as a global object so we can call it from anywhere
     * for example from the Mediator 
     */
    return {
      open: function(received, callback) {
        recordDef = theModel.get("record_def_props")
        onDone = callback
        show = true
      }
    }
  }

</script>